export enum BankRoutes {
  BANK_AND_PSP = '/bank-and-psp',
  BANK_AND_PSP_LIST = '/bank-and-psp/list',
  BANK_AND_PSP_CREATE = '/bank-and-psp/list/create',
  BANK_AND_PSP_PAGE = '/bank-and-psp/:bankId',
  BANK_AND_PSP_GENERAL = '/bank-and-psp/:bankId/general',
  BANK_AND_PSP_PAGE_EDIT = '/bank-and-psp/:bankId/general/edit',
  BANK_AND_PSP_PAGE_ADD_DOCUMENTS = '/bank-and-psp/:bankId/general/add-documents',
  BANK_AND_PSP_ACCOUNTS = '/bank-and-psp/:bankId/accounts',
  BANK_AND_PSP_PAGE_CREATE_ACCOUNT = '/bank-and-psp/:bankId/accounts/create-account',
  BANK_AND_PSP_EXTERNAL = '/bank-and-psp/:bankId/external',
  BANK_AND_PSP_EXTERNAL_CREATE = '/bank-and-psp/:bankId/external/create',
  BANK_AND_PSP_EXTERNAL_ITEM = '/bank-and-psp/:bankId/external/:accountId',
  BANK_AND_PSP_LINKED_CUSTOMERS = '/bank-and-psp/:bankId/linked-accounts',
  BANK_AND_PSP_LINKED_CUSTOMERS_CREATE = '/bank-and-psp/:bankId/linked-accounts/create',
  BANK_AND_PSP_INTEGRATION = '/bank-and-psp/:bankId/integration',
  BANK_AND_PSP_INTEGRATION_LOGS = '/bank-and-psp/:bankId/integration-logs',
  BANK_AND_PSP_INTEGRATION_LOGS_ITEM = '/bank-and-psp/:bankId/integration-logs/:logId',
  BANK_AND_PSP_PAGE_PAYMENT_TYPES = '/bank-and-psp/:bankId/integration/payment-types',
  BANK_AND_PSP_ACCOUNT_PAGE = '/bank-and-psp/accounts/:accountId',
  BANK_AND_PSP_ACCOUNT_PAGE_EDIT = '/bank-and-psp/accounts/:accountId/edit',
  BANK_AND_PSP_ACCOUNT_PAGE_EXTERNAL_ACCOUNT = '/bank-and-psp/accounts/:accountId/:externalAccountId',
  BANK_AND_PSP_ACCOUNT_PAGE_ADD_DOCUMENTS = '/bank-and-psp/accounts/:accountId/add-documents',
  INTEGRATIONS_LOGS = '/integration-logs',
  INTEGRATIONS_LOGS_LIST = '/integration-logs/list',
  INTEGRATIONS_LOGS_ITEM = '/integration-logs/list/:logId',
}

export enum TariffsRoutes {
  TARIFFS = '/tariffs',
  TARIFFS_LIST = '/tariffs/list',
  TARIFFS_CREATE_TARIFF = '/tariffs/list/create',
  TARIFFS_INFO = '/tariffs/:tariffId',
  TARIFFS_INFO_ADD_FEE = '/tariffs/:tariffId/add-fee',
  TARIFFS_INFO_FEE = '/tariffs/:tariffId/:feeId',
}

export enum FeesRoutes {
  FEES = '/fees',
  FEES_LIST = '/fees/list',
  FEES_CREATE = '/fees/list/create',
  FEES_ITEM = '/fees/list/:feeId',
}

export enum CardsRoutes {
  CARDS = '/cards',
  CARDS_LIST = '/cards/list',
  CARDS_LIST_ORDER = '/cards/list/order',
  CARD_INFO = '/cards/:cardId',
  CARD_INFO_TRANSACTIONS = '/cards/:cardId/transactions/:id',
  CARD_INFO_TRANSACTION_INFO = '/cards/:cardId/transactions/:id/:transactionId',
  CARD_ORDER = '/cards/:cardId/transactions/:id/order',
  CARD_EDIT = '/cards/:cardId/transactions/:id/edit/:cardEditId',
}

export enum CurrenciesRoutes {
  CURRENCIES = '/currencies',
  CURRENCIES_LIST = '/currencies/list',
  CURRENCIES_ITEM = '/currencies/list/:currencyId',
}
